import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.isSingleButton ? 'span' : 'core-split-button', {
    tag: "component"
  }, [_c(VMenu, {
    attrs: {
      "content-class": "account-filter-menu",
      "max-height": "400",
      "offset-y": "",
      "close-on-click": true,
      "close-on-content-click": false,
      "nudge-bottom": "4"
    },
    on: {
      "input": _vm.handleDropdownChange
    },
    scopedSlots: _vm._u([_vm.isSingleButton ? {
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('core-button', _vm._g(_vm._b({
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.accountFilter'),
            "prepend-icon": "fa-filter",
            "active": _vm.hasSelection,
            "disabled": _vm.isLoading,
            "data-cy": "account_filter"
          }
        }, 'core-button', attrs, false), on))];
      }
    } : {
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('core-button', _vm._g(_vm._b({
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.accountFilter'),
            "prepend-icon": "fa-filter",
            "solid-icon": _vm.hasSelection,
            "disabled": _vm.isLoading,
            "data-cy": "account_filter"
          }
        }, 'core-button', attrs, false), on), [!_vm.iconOnly ? [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.accountFilter')) + "\n        ")] : _vm._e()], 2)];
      }
    }], null, true)
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "pa-0"
  }, [_c(VTextField, {
    staticClass: "mx-3 mt-3 mb-0",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.search'),
      "hide-details": "",
      "clearable": "",
      "autofocus": "",
      "dense": "",
      "data-cy": "account_filter_search"
    },
    model: {
      value: _vm.searchInput,
      callback: function ($$v) {
        _vm.searchInput = $$v;
      },
      expression: "searchInput"
    }
  })], 1), _c(VCardText, {
    staticClass: "pa-0",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c(VList, {
    attrs: {
      "dense": ""
    }
  }, [_c(VListItemGroup, {
    key: `selected-${_vm.dynamicKey}`,
    attrs: {
      "color": _vm.color,
      "multiple": ""
    }
  }, _vm._l(_vm.selectedAccounts, function (account, idx) {
    return _c(VListItem, {
      key: `selected-${idx}`,
      staticClass: "v-list-item--active",
      attrs: {
        "value": account.id
      },
      on: {
        "click": function ($event) {
          return _vm.handleListItemClicked(account.id, true);
        }
      }
    }, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                  " + _vm._s(account.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(account.id) + ")\n                ")])], 1)], 1);
  }), 1), _vm.selectedAccounts.length ? _c(VDivider, {
    staticClass: "my-3 mx-0 px-0"
  }) : _vm._e(), _c(VListItemGroup, {
    key: `list-${_vm.dynamicKey}`,
    attrs: {
      "color": _vm.color,
      "multiple": ""
    }
  }, [_vm._l(_vm.searchResultsWithoutSelected, function (account, idx) {
    return _c(VListItem, {
      key: `list-${idx}`,
      attrs: {
        "value": account.id
      },
      on: {
        "click": function ($event) {
          return _vm.handleListItemClicked(account.id, false);
        }
      }
    }, [!_vm.selectedAccountIds.includes(account.id) ? _c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                  " + _vm._s(account.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(account.id) + ")\n                ")])], 1) : _vm._e()], 1);
  }), !_vm.searchResultsWithoutSelected.length ? _c(VListItem, {
    attrs: {
      "disabled": ""
    }
  }, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(_vm.$i18n_t('Common.noResults')))])], 1)], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1), !_vm.hideReset ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.reset'),
      "prepend-icon": "fa-undo",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleResetClicked
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };